import React from 'react';
import * as Yup from "yup";
import {IProduct} from 'data/interfaces/products';
import {selectProductType} from 'gui/pages/mainRouter/pages/ad';
import {PRODUCT_STATUS_PREVIEW} from 'data/redux/constants/productsConstants';
import AbstractDetailsForm from '../abstractDetailsForm';
import {lazyWithPreloadToPath} from "../../../../../../../data/utils/shortcuts";
import {linksMap} from "../../../../../../../data/utils/constants";

const AdminEditor = lazyWithPreloadToPath(linksMap.control, () => import(/* webpackChunkName: "AdminEditor" , About:'lazy' */ '../adminEditor'));


interface IPreviewDetailsFormProps {
  onSubmit: (formValues) => Promise<any>;
  product: IProduct;
  isAdmin?: boolean;
  setSubmitRef?: any;

  commonFormComponents?: any;
}

const yupSchema = Yup.object({});


const AbstractPreviewDetailsForm = (props: IPreviewDetailsFormProps) => (
  <AbstractDetailsForm
    {...props}
    initialValues={{
      ...(props.isAdmin ? {
        status: props.product.status,
      } : {}),
    }}
    yupSchemaObject={yupSchema}
    formComponents={({setFieldValue, values}) => <>
      {selectProductType({product: {...props.product, status: PRODUCT_STATUS_PREVIEW}} as any)}
      {props.isAdmin ? <AdminEditor isAdmin={props.isAdmin}/> : null}
    </>}
  />
);

AbstractPreviewDetailsForm.defaultProps = {
  onSubmit: (formValues) => new Promise((resolve) => {
    
    setTimeout(resolve, 1000);
  }),
  ticketDetails: {},
  saleDetails: {},
  setSubmitRef: () => {
  },
  commonFormComponents: () => null,
};

export default React.memo(AbstractPreviewDetailsForm);
